<template>
	<div class="relative flex items-end" :class="{ 'min-h-24': !hasImage }">
		<div
			class="w-full pt-18 pb-1.5 text-center text-white px-4.5 z-1"
			:class="{ 'bg-linear-to-t from-neutral-900 min-h-52': hasImage }"
		>
			<p
				aria-live="polite"
				class="font-serif text-2xl transition-opacity duration-300"
				:class="notice ? 'opacity-100' : 'opacity-0'"
			>
				{{ notice }}
			</p>
			<h2 class="mb-4 font-serif text-2xl min-h-lh">{{ title }}</h2>
		</div>

		<img v-if="image && imageUrl" class="absolute object-cover w-full h-full" :src="imageUrl" alt="Afbeelding" />

		<button
			v-if="backTo"
			type="button"
			class="absolute inline-flex items-center justify-center w-10 h-10 rounded-full left-5 top-5 z-10 text-white"
			:class="{
				'bg-neutral-100/20 hover:bg-neutral-100/40': !hasImage,
				'bg-black/60 hover:bg-black/80': hasImage,
			}"
			:aria-label="t('back')"
			@click="router.push(backTo)"
		>
			<ArrowLeftIcon class="h-4" />
		</button>

		<button
			type="button"
			class="absolute inline-flex items-center justify-center w-10 h-10 rounded-full right-5 top-5 z-10 text-white"
			:class="{
				'bg-neutral-100/20 hover:bg-neutral-100/40': !hasImage,
				'bg-black/60 hover:bg-black/80': hasImage,
			}"
			:aria-label="t('close')"
			@click="close"
		>
			<CrossIcon class="h-4" />
		</button>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import bridge from '@thermenresorts/bridge';
import { useRouter, type RouteLocationRaw } from 'vue-router';
import ArrowLeftIcon from '@thermenresorts/icons/svg/arrow-left.svg';
import CrossIcon from '@thermenresorts/icons/svg/cross.svg';

const { t } = useI18n();

const props = withDefaults(defineProps<{
	title?: string
	notice?: string
	image?: string
	backTo?: RouteLocationRaw | null
}>(), {
  title: '',
  notice: '',
  image: '',
  backTo: null,
});

// @ts-expect-error - BASE_URL is available in Vite environment
const baseUrl = import.meta.env.BASE_URL;

const router = useRouter();

const imageUrl = computed(() => {
  if (!props.image) return null;
  if (props.image.startsWith('http')) {
    return props.image;
  }
  return `${baseUrl}assets/headers/${props.image}`;
});

const hasImage = computed(() => !!props.image && !!imageUrl.value);

const close = () => {
  bridge.sendMessage('pre-reservation-flow', 'pre-reservation-flow.close');
};
</script>
